import axios from "axios";
import Swal from "sweetalert2";
import authHeader from "./jwt-token-access/auth-token-header";

const API_URL = "https://rscoreapi.azurewebsites.net/api/";

const axiosApi = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

function showSessionExpiredAlert() {
  Swal.fire({
    title: "Session Expired",
    text: "Your session has expired. Press OK to return to the login page.",
    icon: "warning",
    confirmButtonText: "OK",
    allowOutsideClick: false,
    allowEscapeKey: false,
  }).then(() => {
    localStorage.clear();
    window.location.href = "/login";
  });
}
async function sendErrorEmail(error, requestConfig) {
  try {
    await axios.post('https://realtyspace.co/api/send500.php', {
      url: requestConfig?.url || "",
      method: requestConfig?.method || "",
      message: error.message,
      status: error.response?.status,
      data: error.response?.data || null,
      time: new Date().toISOString(),
      user: localStorage.getItem("userId") || "Unknown",
    });
    
  } catch (e) {
    console.error("Failed to send error email:", e);
  }
}
async function refreshAccessToken() {
  

  
  const refreshToken = localStorage.getItem("refreshToken") || "";
  const userName = localStorage.getItem("userName") || "";
  const currentAccessToken = authHeader().Authorization.replace("Bearer ", "");

  if (!refreshToken || !userName) {
    console.warn("No refresh token or username found. Logging out.");
    showSessionExpiredAlert();
    return;
  }

  try {
    const response = await axios.post(`${API_URL}user/refresh`, {
      userName,
      refreshToken,
      accessToken: currentAccessToken,
    });

    const newToken = response.data.bearerToken;
    const expiresIn = response.data.accessTokenExpiration || 600; 

    localStorage.setItem("token", JSON.stringify({ bearerToken: newToken }));
    localStorage.setItem("tokenExpiry", new Date().getTime() + expiresIn * 1000);
    axiosApi.defaults.headers["Authorization"] = `Bearer ${newToken}`;

    
    return newToken;
  } catch (error) {
    console.error("Failed to refresh token:", error);
    showSessionExpiredAlert();
    throw error;
  }
}

axiosApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
        if (
        originalRequest.url.includes("/user/userlogin") ||
         originalRequest.url.includes("/user/login") ||
        originalRequest.url.includes("/user/refresh")
      ) {
        return Promise.reject(error);
      }
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const newToken = await refreshAccessToken();
        originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
        return axiosApi(originalRequest);
      } catch (refreshError) {
        console.error("Token refresh failed, logging out.");
        showSessionExpiredAlert();
        return Promise.reject(refreshError);
      }
    }
    if (error.response && error.response.status === 500) {
      try {
        //await sendErrorEmail(error, originalRequest);
      } catch (e) {
       
      }
      //window.location.href = "/error-500";
    }
    return Promise.reject(error);
  }
);

function scheduleTokenRefresh() {
  const expiryTimestamp = localStorage.getItem("tokenExpiry");
  if (!expiryTimestamp) {
    console.warn("No token expiry found, skipping refresh scheduling.");
    return;
  }

  const expiryTime = new Date(parseInt(expiryTimestamp, 10));
  const currentTime = new Date().getTime();
  const refreshInMs = Math.max(expiryTime - currentTime - 50000, 0); 

  

  setTimeout(async () => {
    try {
      await refreshAccessToken();
      scheduleTokenRefresh();
    } catch (error) {
      
    }
  }, refreshInMs);
}

// Call this function after user login or token refresh
if (localStorage.getItem("authUser")) {
  scheduleTokenRefresh();
}

export async function get(url, config = {}) {
  return axiosApi
    .get(url, {
      headers: { ...authHeader() },
      ...config,
    })
    .then((response) => response.data);
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, data, {
      headers: { ...authHeader() },
      ...config,
    })
    .then((response) => response.data);
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, data, {
      headers: { ...authHeader() },
      ...config,
    })
    .then((response) => response.data);
}

export async function del(url, config = {}) {
  return axiosApi
    .delete(url, {
      headers: { ...authHeader() },
      ...config,
    })
    .then((response) => response.data);
}
